import { yupResolver } from "@hookform/resolvers/yup";
import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import useLocales from "src/hooks/useLocales";
import { useRecoverPassword } from "src/services/auth/recover_password";
import SnackbarUtils from "src/utils/SnackbarUtils";
import * as Yup from "yup";

import Context from "../context";

export type SendEmailFormValues = {
	email: string;
};

export const useSendEmailForm = () => {
	const [isLoading, setIsLoading] = useState(false);
	const { translate } = useLocales();

	const { mutate } = useRecoverPassword();
	const { actions } = useContext(Context);

	const SendEmailSchema = Yup.object().shape({
		email: Yup.string()
			.email(translate("El email debe ser válido"))
			.required(translate("El email es necesario"))
	});

	const defaultValues = {
		email: ""
	};

	const methods = useForm<SendEmailFormValues>({
		resolver: yupResolver(SendEmailSchema),
		defaultValues
	});

	const onSuccess = (email: string) => {
		actions.setIsSended();
		actions.setEmail(email);
		setIsLoading(false);
	};

	const onError = (response: any) => {
		setIsLoading(false);
		if (response.data && response.data === "AUTH_06") {
			methods.setError("email", { message: translate("tags.AUTH_06") });
		} else {
			showDefaultError();
		}
	};

	const showDefaultError = () => {
		SnackbarUtils.error(
			translate(
				"Se ha producido un error al intentar enviar el correo, por favor inténtelo de nuevo."
			)
		);
	};

	const onSubmit = async (data: SendEmailFormValues) => {
		setIsLoading(true);
		mutate({ email: data.email }, { onSuccess: () => onSuccess(data.email), onError });
	};

	return {
		methods,
		onSubmit: methods.handleSubmit(onSubmit),
		loading: isLoading
	};
};
